import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import { gettext } from '../utils/text';

const renderSearch = (component) => (
    <div className="arena__search__wrapper">
        <div className="input-group">
            <div className="input-group-prepend">
                <span className="input-group-text navbar-light">
                    <i className="icon icon--search" />
                </span>
            </div>
            <input
                className="form-control arena__search"
                placeholder={gettext('Search')}
                onChange={(e) => component.setSearch(e.target.value)}
                value={component.state.query}
            />
            <div className="input-group-append">
                <span className="input-group-text" onClick={() => component.setSearch('')}>
                    <i className="icon icon--cross--dark" />
                </span>
            </div>
        </div>
    </div>
);

const renderSort = (choices, value, onChange) => (
    <div className="arena__header__sort">
        <Dropdown
            options={choices}
            arrowClosed={<i className="icon icon--chevron" />}
            arrowOpen={<i className="icon icon--chevron rotate-180" />}
            onChange={onChange}
            value={value}
        />
    </div>
);

class ArenaBase extends Component {
    static propTypes = {
        query: PropTypes.string.isRequired,
        ordering: PropTypes.string.isRequired,
        search: PropTypes.func.isRequired,
        sort: PropTypes.func.isRequired,
    };

    componentDidUpdate = (prevProps) => {
        const { query } = this.props;
        // This checks whether the `query` prop has changed and is not equal to the `query` in state.
        // Used to initially receive the `query` value from query parameters in URL.
        if (prevProps.query !== query && query !== this.state.query) {
            this.setState({
                query,
            });
        }
    };

    // Since the actual search method is debounced and also performs an API call,
    // we also store the query value in component state.
    setSearch = (query) => {
        this.setState({ query });
        this.search(query);
    };

    // Search is debounced to reduce number of queries made to back-end.
    search = debounce((input) => {
        this.props.search(input);
    }, 500);

    renderSearch = () => renderSearch(this);

    renderSort = (choices) => renderSort(choices, this.props.ordering, (option) => this.props.sort(option.value));
}

export default ArenaBase;



// WEBPACK FOOTER //
// ./src/components/ArenaBase.js